module.exports = __webpack_public_path__ + "static/img/aboutImg1.905ecf37.png";